import {
  VuexModule,
  Module,
  getModule,
  MutationAction,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { DalService } from "@/services/api/dal.service";
import { Account } from "~/dal/account";
import { CounterCheckInfo } from "~/dal/counter.check.info";
import { ServiceInfo } from "~/dal/service.info";
import { ServiceInfoDTO } from "~/dal/service.info.dto";
import { PaysInfoDTO } from "~/dal/pays.info.dto";
import { InvoiceInfoDTO } from "~/dal/invoice.info.dto";
import { PaysInfo } from "~/dal/pays.info";
import { InvoiceInfo } from "~/dal/invoice.info";
import { InvoiceServicesDTO } from "~/dal/invoice.services.dto";
import { PayDetailDTO } from "~/dal/pay.detail.dto";
import { CounterInfo } from "~/dal/counter.info";

@Module({
  dynamic: true,
  store,
  name: "dal",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class DalVuexModule extends VuexModule {
  accounts: Account[] = [];
  AccountId: number = null as any;
  counterList: CounterCheckInfo[] = [];
  payDate: string = null as any;
  serviceId: number = 13;
  serviceInfoList: ServiceInfo[] = [];
  servicesListLoading: boolean = false;
  serviceInfoLength: number = 0;
  paysInfoList: PaysInfo[] = [];
  paysListLoading: boolean = false;
  paysInfoLength: number = 0;
  invoiceInfoList: InvoiceInfo[] = [];
  invoiceListLoading: boolean = false;
  invoiceInfoLength: number = 0;
  counter: CounterInfo[] = [];

  @Mutation
  public async setPaysListLoading(val: boolean) {
    this.paysListLoading = val;
  }

  @Mutation
  public async setPaysInfoList() {
    this.paysInfoList = [];
  }

  @Mutation
  public async setServicesListLoading(val: boolean) {
    this.servicesListLoading = val;
  }

  @Mutation
  public async setServiceId(val: number) {
    this.serviceId = val;
  }

  @Mutation
  public async setCounterList() {
    this.counterList = [];
  }

  @Mutation
  public async setServiceInfoList() {
    this.serviceInfoList = [];
  }

  @Mutation
  public async setAccountId(val: number) {
    if (this.accounts.find(x => x.account_id == val)) this.AccountId = val;
  }

  @MutationAction
  public async getAccounts() {
    const accounts = await DalService.getAccounts();
    return { accounts };
  }

  @MutationAction
  public async getCounterCheckInfo(req: any) {
    const { Account_id, Lang } = req;
    const counterList = await DalService.getCounterCheckInfo(Account_id, Lang);
    return { counterList };
  }

  @MutationAction
  public async getLastPayDate() {
    const res = await DalService.getLastPayDate();
    const payDate = res.result;
    return { payDate };
  }

  @MutationAction
  public async getServiceInfo(req: ServiceInfoDTO) {
    const serviceInfoList = await DalService.getServiceInfo(req);
    const servicesListLoading = false;
    const serviceInfoLength = serviceInfoList.lenght;
    return { serviceInfoList, servicesListLoading, serviceInfoLength };
  }

  @MutationAction
  public async getReceiptInfo(req: PaysInfoDTO) {
    const paysInfoList = await DalService.getReceiptInfo(req);
    const paysListLoading = false;
    const paysInfoLength = paysInfoList.lenght;
    paysInfoList.forEach((element: PaysInfo) => {
      element.details = [];
      element.detailsLoading = false;
    });
    return { paysInfoList, paysListLoading, paysInfoLength };
  }

  @Mutation
  public async setInvoiceListLoading(val: boolean) {
    this.invoiceListLoading = val;
  }

  @Mutation
  public async setInvoiceInfoList() {
    this.invoiceInfoList = [];
  }

  @MutationAction
  public async getAccountInvoices(req: InvoiceInfoDTO) {
    const invoiceInfoList = await DalService.getAccountInvoices(req);
    const invoiceListLoading = false;
    const invoiceInfoLength = invoiceInfoList.lenght;
    invoiceInfoList.forEach((element: InvoiceInfo) => {
      element.details = [];
      element.detailsLoading = false;
    });
    return { invoiceInfoList, invoiceListLoading, invoiceInfoLength };
  }

  @Action
  public async getInvoiceServices(req: InvoiceServicesDTO) {
    return await DalService.getInvoiceServices(req);
  }

  @Action
  public async getReceiptDetails(req: PayDetailDTO) {
    return await DalService.getReceiptDetails(req);
  }

  @MutationAction
  public async getCntCheckInfo(Account_id: number) {
    const counter = await DalService.getCntCheckInfo(Account_id);
    return { counter };
  }

  @Action
  public async getInvoicePrinted(req: any) {
    const { AccountId, BillId, year, month } = req;
    return await DalService.getInvoicePrinted(AccountId, BillId, year, month);
  }

  @Action
  public async getLinkForOnline() {
    return await DalService.getLinkForOnline();
  }

  @Action
  public async deleteAccount(req: any) {
    return await DalService.deleteAccount(req);
  }

  @Action
  public async addNewAccount(req: any) {
    return await DalService.addNewAccount(req);
  }

  @Action
  public async changePassword(req: any) {
    return await DalService.changePassword(req);
  }

  @Action
  public async updatePersonalData(req: any) {
    return await DalService.updatePersonalData(req);
  }

  @Action
  public async isExistEmail(req: any) {
    return await DalService.isExistEmail(req);
  }

  @Action
  public async registration(req: any) {
    return await DalService.registration(req);
  }
}

export const DalModule = getModule(DalVuexModule);
